import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'sonner';
import { Sidebar } from '../../components/layout/Sidebar';
import { Topbar } from '../../components/layout/Topbar';
import { MobileBottomNav } from '../../components/layout/MobileBottomNav';
import { OfflineBanner } from '../../components/shared/OfflineBanner';
import { ProPendingBanner } from '../../components/shared/ProPendingBanner';
import { useSubscriptionFeatures } from '../../api/queries/subscription.queries';
import { setPlanFeatures } from '../../store/slices/planConfigSlice';

export default function DashboardLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const plan = useSelector((s) => s.company.plan);
  // Fetched once here (not inside usePlan()) so every component reading
  // gating state shares one dynamic config load instead of N redundant
  // fetches+dispatches.
  const { data: featuresResp } = useSubscriptionFeatures();
  useEffect(() => {
    if (featuresResp?.data && plan) {
      dispatch(setPlanFeatures({ plan, features: featuresResp.data }));
    }
  }, [featuresResp, plan, dispatch]);

  return (
    <div className="flex h-screen bg-[var(--bg-app)] overflow-hidden">
      <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={()=>setMobileMenuOpen(false)}/>
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <OfflineBanner/>
        <ProPendingBanner/>
        <Topbar onMenuClick={()=>setMobileMenuOpen(true)}/>
        <main className="flex-1 overflow-y-auto pb-20 lg:pb-0">
          <div className="p-4 sm:p-6 max-w-7xl mx-auto">
            <Outlet/>
          </div>
        </main>
      </div>
      <MobileBottomNav/>
      <Toaster position="bottom-right" richColors/>
    </div>
  );
}
